import { find, noop } from 'lodash';
import { useEffect } from 'react';
import { QUESTION_MATRIX_BIPOLAR_STYLES } from '../constants';
import { onScrollDownMessage, toggleQuestionCollapse } from '../utils';

export default function useOnMount({
  rows = [],
  matrixStyle,
  rtl,
  onClickColumn = noop,
}) {
  useEffect(() => {
    // const { onClickColumn, toggleQuestionCollapse } = this;
    if (matrixStyle === QUESTION_MATRIX_BIPOLAR_STYLES.HORIZONTAL) {
      $('#wrapper').on('tap', '.bipolar-horizontal-column', onClickColumn);
      return () => {
        $('#wrapper').off('tap', '.bipolar-horizontal-column');
      };
    }

    if (matrixStyle === QUESTION_MATRIX_BIPOLAR_STYLES.VERTICAL) {
      $('#wrapper').on('tap', '.bipolar-vertical-column', onClickColumn);

      $('#wrapper').on('tap', '.bipolar-vertical-row-labels', (event) => {
        event.preventDefault();
        toggleQuestionCollapse(event.target);
      });
      return () => {
        $('#wrapper').off('tap', '.bipolar-vertical-column');
        $('#wrapper').off('tap', '.bipolar-vertical-row-labels');
      };
    }

    const sliders = $('.bipolar-slider-input');

    for (let i = 0; i < sliders.length; i += 1) {
      $(sliders[i]).slider({
        highlight: true,
        rtl,
      });

      // Each slider has some steps element so we have to
      // get the column id of each step and then
      // position them correct upon the slider
      let stepValues = [];
      const answerId = parseInt($(sliders[i]).attr('data-answer-id'), 10);
      const row = find(rows, ['id', answerId]);
      for (let index = 0; index < row.columns.length; index += 1) {
        stepValues.push(index);
      }

      if (rtl) {
        stepValues = stepValues.reverse();
      }

      const columnsLength = row.columns.length - 1;
      const margin = 100 / columnsLength;
      const gutterMargin = 36 / columnsLength;
      // We have to attach each step the correct column value also
      // get the number of pixels that we should move each step to the left
      $(sliders[i]).closest('.ui-slider').append(`
        <span
          class="bipolar-slider-step"
          style="left: 0;"
          data-slider-step-value="${stepValues[0]}"
        ></span>
      `);
      for (let index = 0; index < columnsLength; index += 1) {
        $(sliders[i]).closest('.ui-slider').append(`
          <span
            class="bipolar-slider-step"
            style="left:calc(${(index + 1) * margin}% - ${(index + 1) *
          gutterMargin}px);"
            data-slider-step-value="${stepValues[index + 1]}"
          ></span>
        `);
      }
    }

    sliders.on('change', (event) => {
      const sliderHandler = $(event.target)
        .siblings('.ui-slider-track')
        .find('.ui-slider-handle');
      sliderHandler.addClass('ui-slider-handle--touched');
    });

    sliders.on('slidestop', (event) => {
      const { value } = event.target;
      const parentAnswerEl = $(event.target).parents('.answer--bipolar');
      parentAnswerEl.addClass('answerClick');
      const answerId = parseInt(parentAnswerEl.attr('id'), 10);
      const row = find(rows, ['id', answerId]);
      const column = row.columns[value];
      parentAnswerEl.attr('data-selected-column-id', column);
      parentAnswerEl.attr('data-selected-column-order', value);
      onScrollDownMessage();
    });

    // When we click in one step we have to
    // set the slider value to the step value
    $('#wrapper').on('tap', '.bipolar-slider-step', (event) => {
      const value = parseInt(
        $(event.target).attr('data-slider-step-value'),
        10,
      );
      const input = $(event.target).siblings('.bipolar-slider-input');
      $(input).val(value);
      $(input).slider('refresh');

      const parentAnswerEl = $(event.target).parents('.answer--bipolar');
      parentAnswerEl.addClass('answerClick');
      const answerId = parseInt(parentAnswerEl.attr('id'), 10);
      const row = find(rows, ['id', answerId]);
      const column = row.columns[value];
      parentAnswerEl.attr('data-selected-column-id', column);
      parentAnswerEl.attr('data-selected-column-order', value);
      onScrollDownMessage();
    });

    return () => {
      const sliderElements = $('.bipolar-slider-input');
      sliderElements.off('change slidestop');
      $('#wrapper').off('tap', '.bipolar-slider-step');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
